export interface EmailEngineConfig {
	queueUrl: string;
	region: string;
	endpoint?: string;
}

export function loadEmailEngineConfig(): EmailEngineConfig {
	const { EMAIL_ENGINE_SQS_URL, EMAIL_ENGINE_SQS_ENDPOINT, AWS_REGION } =
		process.env;

	if (!EMAIL_ENGINE_SQS_URL) {
		throw new Error("EMAIL_ENGINE_SQS_URL config is not set.");
	}

	return {
		queueUrl: EMAIL_ENGINE_SQS_URL,
		region: AWS_REGION || "us-east-1",
		endpoint: EMAIL_ENGINE_SQS_ENDPOINT || undefined
	};
}
